module.exports = __webpack_public_path__ + "img/35.278265ac.png";